import { Component, OnInit } from '@angular/core';

import { ModalContent } from '@ap/modal';
import { ApContentService } from '@ap/content';

import content from './no-available-tokens-modal.content.json';

/**
 * @module IEModalModule
 * @ngdoc component
 * @name IEModalComponent
 */
@Component({
    selector: 'no-available-tokens-modal',
    templateUrl: 'no-available-tokens-modal.component.html',
    standalone: false
})
export class NoAvailableTokensModalComponent extends ModalContent<void> implements OnInit {
    public constructor(private readonly contentService: ApContentService) {
        super();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }
}
